import { render, staticRenderFns } from "./AdminPanel.vue?vue&type=template&id=7537b0b6&scoped=true"
import script from "./AdminPanel.vue?vue&type=script&lang=js"
export * from "./AdminPanel.vue?vue&type=script&lang=js"
import style0 from "./AdminPanel.vue?vue&type=style&index=0&id=7537b0b6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7537b0b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cmdgame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7537b0b6')) {
      api.createRecord('7537b0b6', component.options)
    } else {
      api.reload('7537b0b6', component.options)
    }
    module.hot.accept("./AdminPanel.vue?vue&type=template&id=7537b0b6&scoped=true", function () {
      api.rerender('7537b0b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/AdminPanel.vue"
export default component.exports